import React from "react";
import styles from "../../styles/governance/cards.module.css";
import increase from "../../../src/assets/images/Increase.svg";
import decrease from "../../../src/assets/images/Decrease.svg";

const Cards = ({ title, subHeading, value, changeValue, change }) => {
  return (
    <>
      <div className={styles.cards_container}>
        <div>
          <p className={styles.card_title}>{title}</p>
          <p className={styles.card_subheading}>{subHeading}</p>
        </div>
        <div className={styles.cards_value}>
          <p className={styles.value}>{value}</p>
          <div className={styles.card_value_container}>
            <p
              className={
                change === "increase"
                  ? styles.card_value_inc
                  : change === "decrease"
                  ? styles.card_value_dec
                  : ""
              }
            >
              {changeValue}
            </p>
            {change && (
              <img
                src={change === "increase" ? increase : decrease}
                alt={change}
                style={{ width: "18px" }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;
